import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { fadeLeft, fadeRight } from '../../../animations/animations';
import { LoggedUser } from '../../../models/loggedUser.service';
import { MenuWorkflowService } from './menu-workflow.service';

@Component({
  selector: 'menu-workflow',
  templateUrl: './menu-workflow.component.html',
  styleUrls: ['./menu-workflow.component.scss'],
  animations: [fadeLeft, fadeRight]
})
export class MenuWorkflowComponent implements OnInit {
  @Input('pageId') pageId: string;
  @Input('homepageId') homepageId: string;

  status$ = new BehaviorSubject(false);

  /** Alinha ao FAB: workflow só para quem tem perfil FT. */
  get canShowWorkflow(): boolean {
    return this.user.checkRole('FT');
  }

  constructor(private readonly menuWorkflowService: MenuWorkflowService, private readonly user: LoggedUser) {}

  ngOnInit(): void {
    this.menuWorkflowService.getOpenstatus().subscribe((open) => this.status$.next(open));
  }

  onCloseWorkflow(): void {
    this.menuWorkflowService.closeMenu();
  }
}
